// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUp_title__RUK3c","text":"SignUp_text__dDtUv","signUpWrapper":"SignUp_signUpWrapper__9SUpP"};